export default {
  'serviceMessage.title': 'Transfer Service Message',
  'serviceMessage.popover.trigger': 'Click here for service message',
  'serviceMessage.popover.mobile.trigger': 'Tap here for service message'
};
